<template>
  <PageContainer>
    <SectionContainer class="pt-2">
      <h1>Attire</h1>
      <img src="https://withjoy.com/media/585cbc3b-43dc-487d-8492-37aedb3b7e2b/71a78a60-ec32-11ef-8c3f-fb9b687c5bd0-Dress%20code.png">
    </SectionContainer>
  </PageContainer>
</template>

<script>
import PageContainer from '@/pages/PageContainer'
import SectionContainer from '@/pages/SectionContainer'

export default {
  name: 'AttirePage',
  components: {
    PageContainer,
    SectionContainer,
  },
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
  },
}
</script>